var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnlockUsbPortBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "26px",
    viewBox: "0 0 29 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock_usb_port_icon",
    fill: "#1DBBD4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "usb-port"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3846154,0 C15.8361538,0 17,1.125 17,2.5 L17,2.5 L16.9994517,11.944837 C16.9408868,12.2122406 16.9100962,12.4894019 16.9100962,12.7734375 L16.9100962,12.7734375 L16.9100962,14.3828125 L16.0682692,14.3828125 C15.1338413,14.3828125 14.3846154,15.0989844 14.3846154,15.9921875 L14.3846154,15.9921875 L14.3833077,21.25125 L13.0769231,22.5 L13.0769231,25 L5.23076923,25 L5.23076923,22.5 L0,17.5 L0,12.5 L1.30769231,12.5 L1.30769231,2.5 C1.30769231,1.125 2.48461538,0 3.92307692,0 L3.92307692,0 L14.3846154,0 Z M14.3846154,2.5 L3.92307692,2.5 L3.92307692,12.5 L14.3846154,12.5 L14.3846154,2.5 Z M7.84615385,6.25 L7.84615385,8.75 L5.23076923,8.75 L5.23076923,6.25 L7.84615385,6.25 Z M13.0769231,6.25 L13.0769231,8.75 L10.4615385,8.75 L10.4615385,6.25 L13.0769231,6.25 Z",
    id: "Combined-Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "lock_open_black_24dp",
    transform: "translate(15.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.41363636,8.66666667 C6.89181818,7.11333333 5.47909091,6 3.81818182,6 C1.71181818,6 0,7.79333333 0,10 C0,12.2066667 1.71181818,14 3.81818182,14 C5.47909091,14 6.89181818,12.8866667 7.41363636,11.3333333 L10.1818182,11.3333333 L10.1818182,14 L12.7272727,14 L12.7272727,11.3333333 L14,11.3333333 L14,8.66666667 L7.41363636,8.66666667 Z M3.5,12 C2.675,12 2,11.325 2,10.5 C2,9.675 2.675,9 3.5,9 C4.325,9 5,9.675 5,10.5 C5,11.325 4.325,12 3.5,12 Z",
    id: "Shape",
    fill: "#1DBBD4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "1 0 14 0 14 16 1 16"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockUsbPortBlue);
export default __webpack_public_path__ + "static/media/unlock_usb_port_blue.f243b86ed64954d17b6233d04d25893e.svg";
export { ForwardRef as ReactComponent };